/**
 * Inbox Page (Placeholder)
 *
 * Future home of user notifications and messages.
 * Auth is handled by the _app layout.
 */

import { Center, Heading, Stack, Text } from '@cortex/ui';
import { createFileRoute } from '@tanstack/react-router';
import { Inbox } from 'lucide-react';

export const Route = createFileRoute('/_app/_main/inbox/')({
  component: InboxPage,
});

function InboxPage() {
  return (
    <Center className="h-full p-6">
      <Stack align="center">
        <Center className="bg-surface-2 mb-4 h-16 w-16 rounded-full">
          <Inbox className="text-foreground/50 h-8 w-8" />
        </Center>
        <Heading level={1} className="text-xl font-semibold">
          Inbox
        </Heading>
        <Text color="secondary" size="sm" className="mt-2">
          Coming soon! Your notifications and messages will appear here.
        </Text>
      </Stack>
    </Center>
  );
}
